export const languages = [
    { slug: 'en' },
    { slug: 'pl' },
]